import React from "react";
import ProfileBanner from "./profile_banner/ProfileBanner";
import WalletRank from "./wallet_rank/WalletRank";
import VarifyKyc from "./verify_kyc_section/VerifyKyc";
import AccountManagement from "./account_management/AccountManagement";
import PerformanceBonus from "./performance_bonus/PerformanceBonus";
export default function Profile() {
  return (
    <div className="profile-section">
      <ProfileBanner />
      <WalletRank />
      <VarifyKyc />
      <PerformanceBonus />
      <AccountManagement />
    </div>
  );
}
